export const popoverContainerStyles = `
  w-[364px]
`
export const imageContainerStyles = `
  h-[180px] w-full rounded-lg overflow-hidden
  !outline-none !border-none
`

export const tootipContainerStyles = `
  w-fit h-fit rounded-2xl !px-2
  z-[1]
`
export const alertCardContainerStyles = `
  items-center mb-2 py-[12px]
`
